/**
 * @file pages/Home.jsx
 * @description Home page component. High-engagement layout with hero,
 * trending destinations, deals, stats, tours, testimonials, gallery,
 * newsletter, and more. Designed to captivate and retain visitors.
 */

import React from "react";
import Header from "../Components/Layouts/Header";
import Hero from "../Components/Sections/Hero";
import Features from "../Components/Sections/Features";
import CategoryShowcase from "../Components/Sections/CategoryShowcase";
import FeaturedTours from "../Components/Sections/FeaturedTours";
import TourPackages from "../Components/Sections/Package1";
import Testimonial from "../Components/Sections/Testimonial";
import CampusAmbassador from "../Components/Sections/CampusAmbassador";
import FeaturedHotels from "../Components/Sections/FeaturedHotels";
import TrendingDestinations from "../Components/Sections/TrendingDestinations";
import StatsCounter from "../Components/Sections/StatsCounter";
import TravelDeals from "../Components/Sections/TravelDeals";
import InstagramGallery from "../Components/Sections/InstagramGallery";
import Newsletter from "../Components/Sections/Newsletter";
import Footer from "../Components/Layouts/Footer";
import MetaTags from "../Components/SEO/MetaTags";
import { useSiteSettings } from "../Context/SiteSettingsContext";

const Home = () => {
  const { settings } = useSiteSettings();
  const co = settings?.companyInfo || {};
  const seo = settings?.seo || {};
  const social = settings?.socialLinks || {};
  const addr = co.address || {};

  const seoData = {
    title: seo.defaultTitle || "Best Inbound and Outbound Tour Operator in India",
    description: seo.defaultDescription || "Discover the world with Nikaba Travels - India's leading tour operator offering customized travel packages, group tours, and authentic experiences.",
    keywords: seo.defaultKeywords || "travel agency, tour operator, india tours, international tours, holiday packages",
    canonical: "/"
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "TravelAgency",
    "name": co.name || "Nikaba Travels",
    "description": seoData.description,
    "url": "https://nikabatravels.com",
    "logo": "https://nikabatravels.com/assets/Asset 2Nikaba travels - Ci-1.png",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": addr.street || "34-A, DDA Flats, Mata Sundari Road",
      "addressLocality": addr.city || "New Delhi",
      "addressRegion": addr.state || "Delhi",
      "postalCode": addr.postalCode || "110002",
      "addressCountry": "IN"
    },
    "telephone": co.phone || "+91-8002406800",
    "sameAs": [social.facebook, social.twitter, social.instagram].filter(Boolean),
    "offers": {
      "@type": "AggregateOffer",
      "name": "Travel Packages",
      "description": "Wide range of domestic and international travel packages"
    }
  };

  return (
    <div>
      <MetaTags {...seoData} />
      
      {/* Add JSON-LD structured data */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>

      <Header />
      <Hero />
      <TravelDeals />
      <Features />
      <FeaturedHotels />
      <CategoryShowcase />
      <TrendingDestinations />
      <FeaturedTours />
      <StatsCounter />
      <TourPackages />
      <Testimonial />
      <InstagramGallery />
      <CampusAmbassador />
      <Newsletter />
      <Footer />
    </div>
  );
};

export default Home;
